import React, { useState, useEffect } from "react";
import { api } from "../../utils/api";
import { ChevronLeft, Landmark, CreditCard, CheckCircle, AlertCircle, Copy, Check } from "lucide-react";

const formatMoney = (amount) => new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);

export default function ResidentPayment({ resident, setActiveTab }) {
  const [balance, setBalance] = useState(0);
  const [banks, setBanks] = useState([]);
  const [method, setMethod] = useState(null); 
  const [selectedBank, setSelectedBank] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copiedField, setCopiedField] = useState("");

  useEffect(() => {
    api.get(`/statement/${resident.accounting_code}`).then(res => {
      setBalance(res.data.totals.balance);
    }).catch(() => {});

    api.get("/settings").then(r => {
      if (r.data && Array.isArray(r.data.banks)) {
        const formattedBanks = r.data.banks.map(b => 
          typeof b === 'object' ? b : { name: b, iban: "IBAN bilgisi yönetimden istenmelidir.", account_holder: "Başkent Sitesi Yönetimi" }
        );
        setBanks(formattedBanks);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [resident]);

  const handleNotify = () => {
    alert("Ödemeniz başarıyla bildirildi. Teşekkür ederiz.");
    setActiveTab("islemler"); 
  };

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(""), 2000);
  };

  if (loading) return <div className="resident-home-dark" style={{padding:"40px", textAlign:"center", color:"#94a3b8"}}>Veriler yükleniyor...</div>;

  const totalWithCommission = balance > 0 ? balance * 1.10 : 0;
  const paymentDescription = `Başkent Sitesi Aidat ${resident.accounting_code}`;

  return (
    <div className="resident-home-dark" style={{ animation: "fadeIn 0.3s ease-out" }}>
      
      <button onClick={() => method ? setMethod(null) : setActiveTab("home")} style={{ background: "none", border: "none", color: "#94a3b8", display: "flex", alignItems: "center", gap: "6px", marginBottom: "20px", fontWeight: "bold", cursor: "pointer" }}>
        <ChevronLeft size={20} /> Geri Dön
      </button>
      
      <h2 style={{ color: "white", marginBottom: "8px" }}>Ödeme İşlemi</h2>
      <p style={{ color: "#94a3b8", marginBottom: "24px" }}>Kapatılacak bakiye tutarı: <strong style={{color: "#10b981", fontSize:"18px"}}>{formatMoney(balance)} TL</strong></p>

      {/* 1. AŞAMA: ÖDEME YÖNTEMİ SEÇİMİ */}
      {!method && (
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <button onClick={() => setMethod("havale")} style={{ background: "#1e293b", border: "1px solid #334155", padding: "20px", borderRadius: "12px", color: "white", display: "flex", alignItems: "center", gap: "16px", cursor: "pointer", transition: "all 0.2s" }}>
            <div style={{ background: "#3b82f6", padding: "12px", borderRadius: "50%" }}><Landmark size={24} /></div>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: "16px", fontWeight: "bold" }}>Hesaba Havale / EFT</div>
              <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>Banka uygulamasına kopyala/yapıştır</div>
            </div>
          </button>

          <button onClick={() => setMethod("kk")} style={{ background: "#1e293b", border: "1px solid #334155", padding: "20px", borderRadius: "12px", color: "white", display: "flex", alignItems: "center", gap: "16px", cursor: "pointer", transition: "all 0.2s" }}>
            <div style={{ background: "#10b981", padding: "12px", borderRadius: "50%" }}><CreditCard size={24} /></div>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: "16px", fontWeight: "bold" }}>Kredi Kartı ile Öde</div>
              <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>%10 Banka komisyonu ile ({formatMoney(totalWithCommission)} TL)</div>
            </div>
          </button>
        </div>
      )}

      {/* 2. AŞAMA: HAVALE / BANKA SEÇİMİ */}
      {method === "havale" && !selectedBank && (
        <div style={{ animation: "slideUp 0.3s ease-out" }}>
          <h3 style={{ color: "white", fontSize: "15px", marginBottom: "16px" }}>Lütfen ödeme yapacağınız bankayı seçin:</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {banks.length === 0 ? <p style={{color:"#ef4444"}}>Sistemde kayıtlı banka hesabı bulunamadı.</p> : null}
            {banks.map((b, idx) => (
              <button key={idx} onClick={() => setSelectedBank(b)} style={{ background: "#0f172a", border: "1px solid #334155", padding: "16px", borderRadius: "12px", color: "white", textAlign: "left", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px" }}>{b.name}</span>
                <ChevronLeft size={18} style={{ transform: "rotate(180deg)", color: "#64748b" }} />
              </button>
            ))}
          </div>
        </div>
      )}

      {/* 3. AŞAMA: KOPYALAMA ALANI (Karekod Yerine) */}
      {method === "havale" && selectedBank && (
        <div style={{ animation: "slideUp 0.3s ease-out", background: "white", padding: "24px", borderRadius: "16px", color: "#1e293b" }}>
          <h3 style={{ margin: "0 0 8px 0", color: "#1e293b", fontSize: "18px", textAlign: "center" }}>Havale / EFT Bilgileri</h3>
          <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 20px 0", textAlign: "center" }}>
            Aşağıdaki bilgileri kopyalayarak banka uygulamanızdan transferi gerçekleştirebilirsiniz.
          </p>
          
          <div style={{ background: "#f8fafc", padding: "16px", borderRadius: "12px", border: "1px solid #e2e8f0", marginBottom: "24px" }}>
            
            {/* Alıcı Adı */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0", paddingBottom: "12px", marginBottom: "12px" }}>
              <div style={{ paddingRight: "16px" }}>
                <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>Alıcı / Hesap Sahibi</div>
                <div style={{ fontSize: "14px", fontWeight: "bold", color: "#1e293b" }}>{selectedBank.account_holder || "Başkent Sitesi Yönetimi"}</div>
              </div>
              <button onClick={() => copyToClipboard(selectedBank.account_holder || "Başkent Sitesi Yönetimi", 'name')} style={{ background: copiedField === 'name' ? "#10b981" : "#eff6ff", color: copiedField === 'name' ? "white" : "#3b82f6", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", fontWeight: "bold", transition: "all 0.2s" }}>
                {copiedField === 'name' ? <Check size={16} /> : <Copy size={16} />} {copiedField === 'name' ? "Kopyalandı" : "Kopyala"}
              </button>
            </div>

            {/* IBAN */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0", paddingBottom: "12px", marginBottom: "12px" }}>
              <div style={{ paddingRight: "16px", flex: 1 }}>
                <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>IBAN ({selectedBank.name})</div>
                <div style={{ fontSize: "14px", fontWeight: "bold", color: "#1e293b", wordBreak: "break-all" }}>{selectedBank.iban || "Tanımlanmamış"}</div>
              </div>
              <button onClick={() => copyToClipboard(selectedBank.iban, 'iban')} style={{ background: copiedField === 'iban' ? "#10b981" : "#eff6ff", color: copiedField === 'iban' ? "white" : "#3b82f6", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", fontWeight: "bold", transition: "all 0.2s" }}>
                {copiedField === 'iban' ? <Check size={16} /> : <Copy size={16} />} {copiedField === 'iban' ? "Kopyalandı" : "Kopyala"}
              </button>
            </div>

            {/* Tutar */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0", paddingBottom: "12px", marginBottom: "12px" }}>
              <div>
                <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>Tutar</div>
                <div style={{ fontSize: "16px", fontWeight: "bold", color: "#ef4444" }}>{balance} TL</div>
              </div>
              <button onClick={() => copyToClipboard(balance.toString(), 'amount')} style={{ background: copiedField === 'amount' ? "#10b981" : "#eff6ff", color: copiedField === 'amount' ? "white" : "#3b82f6", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", fontWeight: "bold", transition: "all 0.2s" }}>
                {copiedField === 'amount' ? <Check size={16} /> : <Copy size={16} />} {copiedField === 'amount' ? "Kopyalandı" : "Kopyala"}
              </button>
            </div>

            {/* Açıklama */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ paddingRight: "16px" }}>
                <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "4px" }}>İşlem Açıklaması (Zorunlu)</div>
                <div style={{ fontSize: "14px", fontWeight: "bold", color: "#1e293b" }}>{paymentDescription}</div>
              </div>
              <button onClick={() => copyToClipboard(paymentDescription, 'desc')} style={{ background: copiedField === 'desc' ? "#10b981" : "#eff6ff", color: copiedField === 'desc' ? "white" : "#3b82f6", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", fontWeight: "bold", transition: "all 0.2s" }}>
                {copiedField === 'desc' ? <Check size={16} /> : <Copy size={16} />} {copiedField === 'desc' ? "Kopyalandı" : "Kopyala"}
              </button>
            </div>

          </div>
          
          <button onClick={handleNotify} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", width: "100%", background: "#10b981", color: "white", border: "none", padding: "16px", borderRadius: "12px", fontSize: "16px", fontWeight: "bold", cursor: "pointer", boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)" }}>
            <CheckCircle size={20} /> Ödemeyi Yaptım / Bildir
          </button>
        </div>
      )}

      {/* KREDİ KARTI PLACEHOLDER */}
      {method === "kk" && (
        <div style={{ background: "#1e293b", border: "1px solid #334155", padding: "24px", borderRadius: "16px", textAlign: "center", color: "white" }}>
          <AlertCircle size={48} color="#3b82f6" style={{ margin: "0 auto 16px auto" }} />
          <h3 style={{ margin: "0 0 8px 0" }}>Sanal POS Bakımda</h3>
          <p style={{ color: "#94a3b8", fontSize: "14px", lineHeight: "1.5" }}>Kredi kartı ile ödeme altyapısı (Paragontek Bilişim) şu anda entegrasyon aşamasındadır. Lütfen şimdilik "Hesaba Havale" yöntemini kullanınız.</p>
        </div>
      )}

    </div>
  );
}